module.exports = __webpack_public_path__ + "img/cert-icon.12bebd2b.svg";